import { usePostApiUserSettingsMutation } from 'applications/GSP/shared/api/gsp';
import { MutationCacheKey } from 'applications/GSP/shared/constants/mutation';

export const useIsMutatingUserSettings = () => {
  const [, { isLoading }] = usePostApiUserSettingsMutation({
    fixedCacheKey: MutationCacheKey.UserSettingsMutation,
  });

  return isLoading;
};
